import script from "./AdminWebForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminWebForm.vue?vue&type=script&setup=true&lang=js"

import "./AdminWebForm.vue?vue&type=style&index=0&id=5ac0faf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac0faf4"]])

export default __exports__